import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/StorefrontsResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/storefronts`;
	}
	list(e) {
		return this.api.get(this.buildPath(n.baseUrl, e));
	}
};
export { n as StorefrontsResource };

//# sourceMappingURL=StorefrontsResource.js.map